import { useState } from 'react'
import { Eye, MoreHorizontal, Trash2, UserPen } from 'lucide-react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '../components/ui/table'
import { Endpoints } from '@/remote/endpoints'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/view/components/ui/dropdown-menu'
import { Button } from '@/view/components/ui/button'
import { DialogDelete } from '../modals/modal-delete'
import { ScrollArea } from './ui/scroll-area'
import { ExerciseFormData } from '../validators/exercise-validator'
import { DialogCreateExercise } from '../modals/modal-crete-exercise'
import { DialogDetailExercise } from '../modals/modal-detail-exercise'
import { DialogEditExercise } from '../modals/modal-edit-exercise'

type TableExerciseProps = {
  data: ExerciseFormData[],
  height?: string,
  getRefreshList?: () => void
}

type ModalState = {
  type: 'create' | 'edit' | 'delete' | 'detail' | null;
  isOpen: boolean;
  dataId?: number;
}

export function TableExercise({ data, height, getRefreshList }: TableExerciseProps) {

  const [modalState, setModalState] = useState<ModalState>({
    type: null,
    isOpen: false,
    dataId: undefined
  });

  const handleOpenModal = (type: ModalState['type'], dataId?: number) => {
    setModalState({
      type,
      isOpen: true,
      dataId
    });
  };

  const handleCloseModal = () => {
    setModalState({
      type: null,
      isOpen: false,
      dataId: undefined
    });
  };

  const renderModal = () => {
    switch (modalState.type) {
      case 'create':
        return (
          <DialogCreateExercise
            closeDialog={handleCloseModal}
            isOpen={modalState.isOpen}
            updateList={getRefreshList}
          />
        );
      case 'edit':
        return (
          <DialogEditExercise
            updateList={getRefreshList}
            closeDialog={handleCloseModal}
            id={modalState.dataId!}
            isOpen={modalState.isOpen}
          />
        );
      case 'delete':
        return (
          <DialogDelete
            updateList={getRefreshList}
            closeDialog={handleCloseModal}
            id={modalState.dataId!}
            isOpen={modalState.isOpen}
            url={Endpoints.exercise}
            label='Exercício'
            unidade='idUnidade'
          />
        );
      case 'detail':
        return (
          <DialogDetailExercise
            id={modalState.dataId!}
            closeDialog={handleCloseModal}
            isOpen={modalState.isOpen}
          />
        );
      default:
        return null;
    }
  };



  return (
    <div className={'overflow-y-auto' + height}>
      {renderModal()}
      <ScrollArea className="m-4 h-container-members-list relative">
        <Table className='border-none'>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Nome</TableHead>
              <TableHead>Descrição</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((exercise: ExerciseFormData, position: number) => (
              <TableRow key={position} className='text-gray-600'>
                <TableCell>{exercise?.id || 'Sem Id'}</TableCell>
                <TableCell
                  className='flex gap-2 capitalize cursor-pointer text-acelerafit-gray-dark hover:text-cashfit-green-200'
                  onClick={() => handleOpenModal('detail', exercise?.id)}
                >
                  {exercise.nome}
                </TableCell>
                <TableCell>{exercise?.descricao}</TableCell>
                <TableCell>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <span className="sr-only">Abrir Menu</span>
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="center">
                      <DropdownMenuLabel>Ações</DropdownMenuLabel>
                      <DropdownMenuItem
                        className='flex gap-2 cursor-pointer'
                        onClick={() => handleOpenModal('detail', exercise?.id)}
                      >
                        <Eye height={24} width={30} className='text-blue-500 cursor-pointer p-1 hover:text-blue-400' />
                        Detalhes
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem
                        className='flex gap-2 cursor-pointer'
                        onClick={() => handleOpenModal('edit', exercise?.id)}
                      >
                        <UserPen height={24} width={30} className='text-blue-500 cursor-pointer p-1 hover:text-blue-400' />
                        Editar
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem
                        className='flex gap-2 cursor-pointer'
                        onClick={() => handleOpenModal('delete', exercise?.id)}
                      >
                        <Trash2 height={24} width={30} className='text-red-500 cursor-pointer p-1 hover:text-red-400' />
                        Apagar
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  )
}